module.exports = __webpack_public_path__ + "img/hindustan-times.d525b510.png";